/** Underlined tab button shared by the Organization and Group detail views. */
export default function TabButton({
  active,
  label,
  onClick,
  id,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
  id?: string;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      id={id}
      style={{
        appearance: "none",
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "10px 4px",
        fontFamily: "var(--font-lato)",
        fontSize: 15,
        fontWeight: active ? 700 : 500,
        color: active ? "var(--color-rodeo-black)" : "var(--color-graphite)",
        borderBottom: `2px solid ${active ? "var(--color-dark-dust)" : "transparent"}`,
      }}
    >
      {label}
    </button>
  );
}
